const flaggedContentEN = {
    "view": {
        "form": {
            "button": {
                "viewDetails": "View Details"
            },
            "message": {
                "releaseHasBeenAddedToWhitelist": "Release <strong>{{releaseName}}</strong> has been added to the whitelist.",
                "releaseHasFlaggedContent": "Release <strong>{{releaseName}}</strong> contains flagged tracks. A fee of <strong>15 €</strong> per flagged track applies to deliver it to <strong>Spotify</strong>.<br/><br/> Click the button below to complete your payment and continue."
            },
            "modal": {
                "header": {
                    "titleFlaggedTracksDetails": "Flagged Tracks Details",
                    "titleFlaggedTrackPayment": "Spotify Whitelisting Payment"
                },
                "body": {
                    "table": {
                        "title": "The following tracks have been flagged. Please review the details below:",
                        "column": {
                            "name": "Track Name",
                            "flaggedArtist": "Flagged Artist", 
                            "payableAmount": "Payable Amount",
                            "paymentStatus": "Payment Status",
                        },
                        "label": {
                            "payableAmount": "15 €",
                            "paid": "PAID",
                            "pending": "PENDING",
                        }
                    },
                    "label": {
                        "processingPayment": "Processing Payment...",
                        "paymentSuccessful": "Payment Successful!",
                        "paymentFailed": "Payment Failed!"
                    },
                    "message": {
                        "totalPayableAmount": "To complete the delivery of your release to <strong>Spotify</strong>, a refundable deposit of <strong>{{totalAmount}} €</strong> is required. Please accept the terms below and click <strong>Proceed</strong> button to make your payment.",
                        "escrowAmountAgreement": "I accept and acknowledge that an escrow amount of <strong>{{totalAmount}} €</strong> will be deposited by me. This amount will be held till the <strong>end of subscription</strong> and, provided no issues arise, will be returned to me at the end of this period. However, if I violate the terms of this agreement during this time, the escrow amount will be applied to the outstanding invoice and will not be refunded. By proceeding, I affirm my understanding and acceptance of these conditions.",
                        "escrowPaymentRejected": "I do not accept the escrow payment terms and, accordingly, acknowledge that my release <strong>{{releaseName}}</strong> will <strong>not be distributed to Spotify</strong>.",
                        "consentRecordedSuccessfully": "Consent Recorded Successfully!",
                    }
                },
                "button": {
                    "proceed": "Proceed",
                }
            }
        }
    }
}

export default flaggedContentEN;